import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRightUpLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M17.9999 5C18.5522 5 18.9999 5.44772 18.9999 6V14C18.9999 14.5523 18.5522 15 17.9999 15C17.4476 15 16.9999 14.5523 16.9999 14V8.41397L7.04988 18.364C6.65936 18.7545 6.02619 18.7545 5.63567 18.364C5.24514 17.9735 5.24514 17.3403 5.63567 16.9498L15.5855 7H9.99992C9.44763 7 8.99992 6.55228 8.99992 6C8.99992 5.44771 9.44763 5 9.99992 5H17.9999Z" })
});
export default SvgArrowRightUpLine;
